// extracted by mini-css-extract-plugin
export default {"heading":"lj-z","list":"mj-z"};